module.exports = __webpack_public_path__ + "img/autumn_collection_bg.37a95e05.jpg";